module.exports = __webpack_public_path__ + "static/media/playground.73cae260.svg";